module.exports = __webpack_public_path__ + "img/brown-carpet-grass-00.0d736963.png";